import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const sections = [
  {
    title: "About BSS Sonata Microcredit",
    links: [
      { label: "About BSS Sonata Microcredit", to: "/about" },
      { label: "Our Approach", to: "/methodology" },
      { label: "Board of Directors", to: "/about#board-of-directors" },
      { label: "Leadership Team", to: "/about#leadership-team" },
      { label: "Annual Report", to: "/reports#annual-report" },
    ],
  },
  {
    title: "Products",
    links: [
      { label: "Microcredit Loan", to: "/products#microcredit-loan" },
      {
        label: "Secured Business Loan (SBL)",
        to: "/products#secured-business-loan-sbl",
      },
    ],
  },
  {
    title: "Important",
    links: [
      { label: "Our Partners", to: "/network" },
      { label: "Code of Conduct", to: "/reports#code-of-conduct" },
    ],
  },
  {
    title: "Quick Links",
    links: [
      { label: "Public Caution Notice", to: "/public-caution-notice" },
      { label: "News & Announcement", to: "/reports#news-and-events" },
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms and Conditions", to: "/terms-and-conditions" },
      { label: "Security Tips", to: "/security-tips" },
      { label: "Cashless Payments", to: "/cashless-payments" },
    ],
  },
  {
    title: "Corporate Identity Number (CIN)",
    links: ["U66190KA1994PLC049746"],
  },
  {
    title: "Get In Touch",
    groups: [
      {
        heading: "Registered Office",
        items: [
          "No. 11, 2nd Block, 2nd Stage Outer Ring Road, Near BDA Complex Nagarabhavi Layout, Bengaluru – 560072",
        ],
      },
      {
        heading: "Phone Numbers",
        items: [
          { heading: "Bengaluru", value: "+91-80-2318839" },
          { heading: "Bengaluru", value: "+91-80-29778389" },
          { heading: "Lucknow", value: "+91-522-2334900" },
        ],
      },
      {
        heading: "Emails",
        items: [{ heading: "Info ", value: "info@bsssonata.com" }],
      },
      {
        heading: "Grievance",
        items: [
          {
            heading: "Redressal",
            value: "Grievance Redressal",
            to: "/contact",
          },
          { heading: "Toll Free", value: "080 60004422" },
          { heading: "Toll Free", value: "18002100102" },
          { heading: "Email", value: "gv@bsssonata.com" },
        ],
      },
    ],
  },
];

const Footer = () => {
  return (
    <>
      <footer className="relative bg-black text-gray-300 pt-8 pb-3 px-6 border-b border-t border-white1 overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {sections.map((section, index) => (
              <motion.div
                className={`${
                  section.groups
                    ? "mb-4"
                    : "flex flex-col sm:flex-row sm:items-center gap-2 mb-3"
                }`}
                key={index}
                transition={{ type: "spring", stiffness: 200 }}
              >
                <h3 className="text-white text-base font-normal tracking-wide relative mb-1">
                  {section.title} :
                </h3>

                {/* Case 1: Normal links */}
                {section.links && (
                  <ul className="flex flex-wrap ms-0 sm:ms-3 gap-1">
                    {section.links.map((link, linkIndex) => {
                      const linkData =
                        typeof link === "string"
                          ? { label: link, to: "#" }
                          : link;
                      const content = (
                        <>
                          <span className="relative z-10">
                            {linkData.label}
                          </span>
                          <span className="absolute inset-x-0 bottom-0 h-[1px] bg-red-500 scale-x-0 hover:scale-x-100 origin-left transition-transform duration-300"></span>
                        </>
                      );

                      return (
                        <motion.li
                          key={linkData.label}
                          whileHover={{ x: 5 }}
                          className="flex items-center gap-1"
                        >
                          {linkData.to ? (
                            <Link
                              to={linkData.to}
                              className="relative inline-block text-white2 hover:text-red transition duration-300 text-sm"
                            >
                              {content}
                            </Link>
                          ) : (
                            <span className="text-white2 text-sm">
                              {linkData.label}
                            </span>
                          )}
                          {linkIndex !== section.links.length - 1 && (
                            <span className="text-white2">|</span>
                          )}
                        </motion.li>
                      );
                    })}
                  </ul>
                )}
                {section.groups && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
                    {section.groups.map((group, gIndex) => (
                      <div key={gIndex} className="p-2">
                        <h4 className="text-white font-normal mb-1">
                          {group.heading}
                        </h4>
                        <ul>
                          {group.items.map((item, itemIndex) => {
                            // agar item object hai
                            if (typeof item === "object" && item.value) {
                              let linkType = null;
                              const to = item.to;

                              if (item.value.includes("@")) {
                                linkType = `mailto:${item.value}`;
                              } else if (/[\d\s-]+$/.test(item.value)) {
                                linkType = `tel:${item.value.replace(
                                  /\s+/g,
                                  ""
                                )}`;
                              }

                              return (
                                <motion.li
                                  key={itemIndex}
                                  whileHover={{ x: 5 }}
                                >
                                  <span className="font-semibold text-white">
                                    {item.heading}:
                                  </span>{" "}
                                  {to ? (
                                    <Link
                                      to={to}
                                      className="relative inline-block text-white2 hover:text-red transition duration-300 text-sm"
                                    >
                                      {item.value}
                                    </Link>
                                  ) : linkType ? (
                                    <Link
                                      to={linkType}
                                      className="relative inline-block text-white2 hover:text-red transition duration-300 text-sm"
                                    >
                                      {item.value}
                                    </Link>
                                  ) : (
                                    <span className="text-white2 text-sm">
                                      {item.value}
                                    </span>
                                  )}
                                </motion.li>
                              );
                            }

                            // agar item sirf string hai (jaise address)
                            return (
                              <motion.li key={itemIndex} whileHover={{ x: 5 }}>
                                <span className="text-white2 text-sm">
                                  {item}
                                </span>
                              </motion.li>
                            );
                          })}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </footer>
      {/* Footer bottom */}
      <div className="py-3 text-center text-white text-sm bg-black">
        © 2025
        <span className="font-semibold"> BSS Sonata Microcredit Ltd. </span>
        All rights reserved.{" "}
        <span className=" font-semibold">Developed by BSS Sonata IT Team</span>
      </div>
    </>
  );
};

export default Footer;
